module.exports = __webpack_public_path__ + "img/DIDnPBX.731bef53.png";